/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Risks_UrgencyInputs */

const en_footer_risks_urgency = /** @type {(inputs: Footer_Risks_UrgencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urgency`)
};

/**
* | output |
* | --- |
* | "Urgency" |
*
* @param {Footer_Risks_UrgencyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_risks_urgency = /** @type {((inputs?: Footer_Risks_UrgencyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Risks_UrgencyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_risks_urgency(inputs)
});